export default __webpack_public_path__ + "heart-shape-silhouette.png";